import { EnrichedExercise, NonEnrichedExercise } from '@models';


export const sortExercisesByCode = (
  exerciseA: NonEnrichedExercise | EnrichedExercise,
  exerciseB: NonEnrichedExercise | EnrichedExercise,
): number => {
  return exerciseA.code.localeCompare(exerciseB.code);
};
